import React from "react";
import { Edit, SimpleForm, Tab, TabbedShowLayout, useGetOne, useTranslate } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { SaveWithCancelWithPasswordChangeToolbar } from '../../../components/toolbars/SaveWithCancelWithPasswordChangeToolbar';
import { UserType } from '../../../entities/UserType';

import { ManagerEditForm } from './EditForm';
import { TasksSettingsForm } from './TasksSettingsForm';
import { useOwnerCompanyDataContext } from "../../../contexts/OwnerCompanyDataProvider";


export const ManagerEdit = (props) => {
	const translate = useTranslate();
	const { ownerCompanyData } = useOwnerCompanyDataContext();
	const { data: user } = useGetOne(props.resource, props.id);

	const mainTitle = translate(`resources.${props.resource}.name`, {company_name: ownerCompanyData.short_name});
	const title = `${mainTitle} #${props.id}`;

	const generalEdit = (
		<Edit {...props} undoable={false} title={title}>
			<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelWithPasswordChangeToolbar />}>
				<ManagerEditForm />
			</SimpleForm>
		</Edit>
	);

	// Task assignment settings only apply to the employee role
	if (!user || user.type !== UserType.employee) {
		return generalEdit;
	}

	return (
		<TabbedShowLayout
			style={{ paddingBottom: 8 }}
			basePath={props.basePath}
			syncWithLocation={true}
		>
			<Tab label="tab.geneneral.name">
				{generalEdit}
			</Tab>
			<Tab label="tab.tasks_settings.name" path="tasks-settings">
				<Edit {...props} undoable={false} title={title} actions={null}>
					<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
						<TasksSettingsForm />
					</SimpleForm>
				</Edit>
			</Tab>
		</TabbedShowLayout>
	);
};
